import React, { useState, useEffect } from 'react';
import AWS from 'aws-sdk';
import "./Card.css"
import Navbar from '../Navbar/Navbar';

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});
const s3 = new AWS.S3();

function CaseStudiesMenu({handleLogout}) {
  const [error, setError] = useState('');

  const openPdf = (key) => {
    const params = {
      Bucket: 'git-dash-bucket',
      Key: key,
    };

    s3.getObject(params, (err, data) => {
      if (err) {
        console.error('Error fetching PDF:', err);
        setError(`Error fetching PDF (${key}).`);
      } else {
        const blob = new Blob([data.Body], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      }
    });
  };
    return (
      <div className="case-studies-menu">
        
        <h2 class="stories-heading">Our Success Stories</h2>
        <div className="case-study-cards">
          {/* Card 1 */}
          <div className="case-study-card">
              <h3>Bahri Jana</h3>
              <div className="card-footer">
                <img src="https://www.shipspotting.com/photos/big/5/1/8/2553815.jpg?cb=0" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">October 28, 2023</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Prop, Fuel Red</div>
                <div className="performance-change">
                    Performance increased: 10% 
                    <div className="upward-triangle"></div>
                </div>
                </div>
                </div>
          </div>

          {/* Card 2 */}
          <div className="case-study-card">
                <h3>Bahri Khuzama</h3>
                <div className="card-footer">
                <img src="https://static.vesselfinder.net/ship-photo/9384215-403562000-bef2877224ca22e71229c13f9a291619/1?v1" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">August 27, 2023</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Prop</div>
                <div className="performance-change">
                  Performance increased: 4% 
                    <div className="upward-triangle"></div>
                </div>
                </div>
                </div>
            </div>

          {/* Card 3 */}
          <div className="case-study-card" onClick={() => openPdf('Stena Scotia Preliminary Analysis.pdf')}>
              <h3>Stena Scotia</h3>
              <div className="card-footer">
                <img src="https://www.niferry.co.uk/wp-content/uploads/2018/08/Stena-Scotia-Belfast-arrival3_SM-copy-1200x900.jpg" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">July 10, 2023</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Fuel Red</div>
                <div className="performance-change">
                                    Performance increased: 10%
                                    <div className="upward-triangle"></div>
                                </div>
                </div>
                </div>
          </div>

           {/* Card 4 */}
           <div className="case-study-card" onClick={() => openPdf('Performance Report_OSV_XGIT-FUEL_2023.pdf')}>
           <h3>Polar Prince</h3>
           <div className="card-footer">
             <img src="https://1.bp.blogspot.com/-bCLfX62q9o8/YaAlgHCYrZI/AAAAAAAAxa8/lMbKuhnuUK4cebYvnTw3xDd9V81C-ieAgCLcBGAsYHQ/s2048/IMG_0352%2BPolar%2BPrince.jpg" 
                 alt="Case Study Image" className="case-study-image" />
             <div className="card-footer-content">
               <div className="date-container">
             <span className="date-label">DD Date:</span>
             <span className="date">May 19, 2022</span>
             </div>
             <div className="performance-change1"><p>Product Applied:</p> Fuel White</div>
             <div className="performance-change">
                                 Performance increased: 10%
                                 <div className="upward-triangle"></div>
                             </div>
             </div>
             </div>
         
       </div>

        {/* Card 5 */}
        <div className="case-study-card" onClick={() => openPdf('1-Year Performance Report_FISK_XGIT-FUEL_2022-2023.pdf')}>
           <h3>Finnlines - Finnsky</h3>
           <div className="card-footer">
             <img src="https://static.vesselfinder.net/ship-photo/9468906-230622000-3910095e9ee9692e0e86cac6a8e5b875/1?v1" 
                 alt="Case Study Image" className="case-study-image" />
             <div className="card-footer-content">
               <div className="date-container">
             <span className="date-label">DD Date:</span>
             <span className="date">September 05, 2022</span>
             </div>
             <div className="performance-change1"><p>Product Applied:</p> Fuel White</div>
             <div className="performance-change">
                                 Performance increased: 10%
                                 <div className="upward-triangle"></div>
                             </div>
             </div>
             </div>  
       </div>

        {/* Card 6 */}
        <div className="case-study-card" onClick={() => openPdf('Performance Report_RORO_XGIT-FUEL_2023.pdf')}>
           <h3>Kotug Canada - K.J. Gardner</h3>
           <div className="card-footer">
             <img src="https://assets-global.website-files.com/5d97efece288d82cde97d5f3/6570002417f7e297b90cf2bd_Oil-Ship-1.png" 
                 alt="Case Study Image" className="case-study-image" />
             <div className="card-footer-content">
               <div className="date-container">
             <span className="date-label">DD Date:</span>
             <span className="date">December 19, 2022</span>
             </div>
             <div className="performance-change1"><p>Product Applied:</p> Fuel White</div>
             <div className="performance-change">
                                 Performance increased: 10%
                                 <div className="upward-triangle"></div>
                             </div>
             </div>
             </div>
       </div>

          {/* Card 7 */}
          <div className="case-study-card">
              <h3>Stolt Acer</h3>
              <div className="card-footer">
                <img src="https://static.vesselfinder.net/ship-photo/9272668-636017838-51a27c9014df9a2aa4f3abfe47f8e9a9/1?v1" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">March 21, 2024</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Prop</div>
                <div className="performance-change">
                    Performance increased: 4% 
                    <div className="upward-triangle"></div>
                </div>
                </div>
                </div>
          </div>
          <div className="case-study-card">
            <a href="/case-study-5">
              <h3>Stolt Vision</h3>
              <div className="card-footer">
                <img src="https://static.vesselfinder.net/ship-photo/9274329-636015738-701dc469acd7d3820e432ca4dee2af27/1?v1" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">February 21, 2023</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Prop</div>
                <div className="performance-change">
                    Performance increased: 4% 
                    <div className="upward-triangle"></div>
                </div>
                </div>
                </div>
            </a>
          </div>
          
          <div className="case-study-card">
              <h3>Maersk Barry</h3>
              <div className="card-footer">
                <img src="https://photos.marinetraffic.com/ais/showphoto.aspx?photoid=2287192" 
                    alt="Case Study Image" className="case-study-image" />
                <div className="card-footer-content">
                  <div className="date-container">
                <span className="date-label">DD Date:</span>
                <span className="date">July 14, 2023</span>
                </div>
                <div className="performance-change1"><p>Product Applied:</p> Prop</div>
                <div className="performance-change">
                    Performance increased: 4% 
                    <div className="upward-triangle"></div>
                </div>
                </div>
                </div>
          </div>
        </div>
      </div>
    );
  }
  
  
  export default CaseStudiesMenu;